import React from "react";
var VerificationMsg = function (props) {
    var _a;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "verification-msg-container  ".concat((_a = props === null || props === void 0 ? void 0 : props.parentClassName) !== null && _a !== void 0 ? _a : "") },
            (props === null || props === void 0 ? void 0 : props.icon) && React.createElement("i", { className: props === null || props === void 0 ? void 0 : props.icon }), props === null || props === void 0 ? void 0 :
            props.message)));
};
export default VerificationMsg;
